require('dropzone')
import Dropzone from "dropzone"

var appendContent, appendFlash, createImageList, imageDropzone;
Dropzone.autoDiscover = false;
Dropzone.maxFilesize = 500;

$(document).on('turbolinks:load', function() {
  if ($('.dropzone').length > 0) {
    // Disable 30 second timeout for larger files.
    imageDropzone = $(".dropzone").dropzone(
      {
        timeout: 0,
      }
    );
    Dropzone.options.imageDropzone = false;

    // imageDropzone.on('drop', function(files) {
    //   console.log('item was dropped');
    // });

    // imageDropzone.on('success', function(files) {
    //   console.log('item success');
    //   var _this;
    //   _this = this;
      // if (_this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
      //   setTimeout((function() {
      //     var acceptedFiles, file, index, rejectedFiles, response;
      //     // $('#dropzone-modal').modal('hide');
      //     acceptedFiles = _this.getAcceptedFiles();
      //     rejectedFiles = _this.getRejectedFiles();
      //     index = 0;
      //     while (index < acceptedFiles.length) {
      //       file = acceptedFiles[index];
      //       response = JSON.parse(file.xhr.response);
      //       // appendContent(file.dataURL, response.id);
      //       appendFlash(file.dataURL, response.id);
      //       index++;
      //     }
      //     _this.removeAllFiles();
      //   }), 2000);
      // }
    // });

    // imageDropzone.on('error', function(files) {
    //   $('body').append("<div class='alert alert-danger'><div class='container'><button class='close' data-dismiss='alert'><span>×</span></button><strong>Error!<strong> Asset upload failed</div></div>");
    //   imageDropzone.removeAllFiles;
    // });

    // imageDropzone.on('addedfile', function(files) {
    //   console.log('file was added');
    //   // $('#dropzone-modal .modal-body .alert-danger').slideUp().remove();
    // });
  }
});

appendContent = function(imageUrl, imageId) {
  var hiddenImageId, imageRow, imageTypeList, imageTypes, rowCount;
  rowCount = $('#image-contents tbody tr').length;
  imageTypeList = $('#product_product_type_id').find(':selected').data('image-types');
  imageTypes = '<select name="product[images_attributes][' + rowCount + '][image_type_id]" class="dynamicSelect2 form-control"><option>Select Type</option>' + createImageList(imageTypeList) + '</select>';
  hiddenImageId = '<input type="hidden" value="' + imageId + '" name="product[images_attributes][' + rowCount + '][id]" id="product_images_attributes_' + rowCount + '_id" style="">';
  imageRow = '<tr class="js-dynamic-image-row"><td class="sort-td-handle sort-handle"><i class="far fa-bars"></i><i class="far fa-sort"></i></td><td><img class="thumb" src="' + imageUrl + '"/></td><td>' + imageTypes + '</td><td><a href="/images/' + imageId + '"/hotspots">hotspots</a></td><td><a data-confirm="Are you sure?" class="btn btn-xs btn-link delete-btn" data-remote="true" rel="nofollow" data-method="delete" href="/images/' + imageId + '"><i class="far fa-times"></i></a></td></tr>' + hiddenImageId;
  $('#image-contents').append(imageRow);
  $('#delete').removeAttr('disabled');
  $('#delete-all').removeAttr('disabled');
  $('#no-image').html('');
  $('.dynamicSelect2').select2();
};

appendFlash = function(imageUrl, imageId) {
  console.log('append flash');
  $('body').append('<div class="alert alert-info"><div class="container"><button class="close" data-dismiss="alert"><span>×</span></button><strong>Success!<strong> ' + imageId + ' uploaded</div></div>');
  console.log('files should be removed');
};

createImageList = function(imageTypeList) {
  var tmpList;
  tmpList = $.map(imageTypeList, function(itemType) {
    return "<option value='" + itemType.id + "'>" + itemType.name + "</option>";
  });
  return tmpList.toString();
};

$(document).on('click', '#image-contents .delete-btn', function(e) {
  var row;
  row = $(this).closest('tr');
  row.next('input[type=hidden]').remove();
  row.replaceWith("<tr class='success'><td colspan='10'>Successfully removed!</td></tr>");
  $('tr.success').slideUp();
});
